<template>
	<div ref="el" data-component="products">
		<TopNote :title="topNote" icon="product" />

		<div class="cards g-row">
			<div v-for="(product, i) in productsList" :key="i" class="g-col card-container xxl-8 sm-16">
				<ProductCard v-bind="product" :even="i % 2 === 0" />
			</div>
		</div>

		<div class="description">
			<HighlightedText :text="description" size="small" />
		</div>
	</div>
</template>

<script setup>
import { TopNote, ProductCard, HighlightedText } from '~/components/primitives'

const props = defineProps({
	topNote: { type: String, default: undefined },
	productsList: { type: Array, default: undefined },
	description: { type: Object, default: undefined },
})

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {})
</script>

<style lang="scss" scoped>
[data-component='products'] {
	position: relative;

	width: 100%;

	padding-top: rs(150, 150);

	@include max-width($sm) {
		padding-top: rs(120, 120);
	}

	.cards {
		@include max-width($sm) {
			padding-bottom: rs(40, 40);
		}

		.card-container {
			padding-bottom: rs(120, 120);

			padding-left: rs(32);
			padding-right: rs(32);

			@include max-width($lg) {
				padding-left: rs(16, 16);
				padding-right: rs(16, 16);
			}

			@include max-width($sm) {
				padding-bottom: rs(24, 24);

				padding-left: rs(120);
				padding-right: rs(120);
			}

			@include max-width($xs) {
				padding-left: 0;
				padding-right: 0;
			}
		}
	}

	.description {
		width: column-width(8);
		margin: 0 auto;

		padding-bottom: rs(120, 120);

		@include max-width($sm) {
			width: column-width(14);
			padding-bottom: rs(64, 64);
		}
	}
}
</style>
